import script from "./AdminCoins.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCoins.vue?vue&type=script&setup=true&lang=js"

import "./AdminCoins.vue?vue&type=style&index=0&id=1288abe9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1288abe9"]])

export default __exports__